import React, { useContext, useEffect } from "react";
import qs from "qs";
import apiClient from "@/utils/apiClient";
import { NextSeo } from "next-seo";
import { Nav } from "@/components/navigation/Navbar";
import Crumbs from "@/components/navigation/Crumbs";
import * as Text from "@/components/text";
import Announcement from "@/components/initiatives/Announcement";
import DownloadableMaterials from "@/components/initiatives/DownloadableMaterials";
import Testimonials from "pages/iniciativa/Testimonials";
import PreviousEditions from "@/components/initiatives/PreviousEditions";
import Partners from "@/components/initiatives/Partners";
import { GlobalContext } from "@/stores/GlobalContextProvider";
import HeroMedia from "@/components/lib/HeroMedia";

export default function AmbulantePresenta({ mediaCenter }) {
  const globalConfiguration = useContext(GlobalContext);

  return (
    <>
      <div className="amb-container">
        <Nav className="bg-gray-100 grow" theme="light" />
        <NextSeo
          title="Ambulante Presenta - Ambulante"
          description="Información general Coordinación de comunicación Sofía Llorente / slz@ambulante.org Coordinación de prensa Icunacury Acosta / prensa@ambulante.org Boletines 2023 Ambulante Gira de Documentales revela la imagen de su decimoctava edición Anunciamos el arranque de Ambulante Presenta 2023 Materiales Ambulante Presenta 2023 Catálogo Ambulante Presenta 2023 Guía de discusión Las colonias Programas de mano ediciones pasadas Ambulante"
          canonical={`https://ambulante.org/ambulante-presenta}`}
          openGraph={{
            url: `https://ambulante.org/ambulante-presenta`,
            title: "Ambulante Presenta - Ambulante",
            description:
              "Información general Coordinación de comunicación Sofía Llorente / slz@ambulante.org Coordinación de prensa Icunacury Acosta / prensa@ambulante.org Boletines 2023 Ambulante Gira de Documentales revela la imagen de su decimoctava edición Anunciamos el arranque de Ambulante Presenta 2023 Materiales Ambulante Presenta 2023 Catálogo Ambulante Presenta 2023 Guía de discusión Las colonias Programas de mano ediciones pasadas Ambulante",
            site_name: "Ambulante",
          }}
        />
        <div className="flex flex-row gap-2 py-4">
          <Crumbs
            breadcrumbs={[
              { href: "/", text: "Inicio" },
              {
                href: "/iniciativa/gira?seccion=las-peliculas",
                text: "Programas",
              },
            ]}
          />
          <Text.NavigationLabel className="mt-0.5 text-xs font-thin text-neutral-600 md:mt-1.5">
            Ambulante Presenta
          </Text.NavigationLabel>
        </div>

      </div>

      <div className="flex flex-col items-center justify-center mb-8 text-center mt-7 md:mt-10 md:px-28 lg:mt-14 lg:px-32">
        <div className="w-full font-bold text-center text-presenta">
          <Text.Title className="text-[22px] md:text-2xl md:font-semibold lg:text-2xl">
            Ambulante Presenta
          </Text.Title>
        </div>
        <div className="w-full px-4 py-2 text-center text-4xl font-bold leading-9 md:mb-4 md:mt-4 md:px-32 md:text-[30px] lg:px-52 lg:text-4xl">
          <h2>{mediaCenter?.title}</h2>
        </div>
        <div className="w-full px-4 text-center md:px-20 lg:px-40">
          <Text.Headline className="text-xl font-normal leading-7 lg:text-[30px]">
            {mediaCenter?.subtitle}
          </Text.Headline>
        </div>
        { mediaCenter?.description ? 
          (
            <div className={`w-full max-w-[950px]  text-center text-sm font-light leading-7 lg:mt-4 lg:text-[18px] lg:leading-[22px] bg-[#fff4d4] p-4 rounded-md`}>
              {mediaCenter?.description}
            </div>
          ) : null
        }
      </div>
      {mediaCenter?.hero_media && <div className="flex items-center justify-center w-full">
        <div className="w-full pb-8 lg:max-w-[1440px] lg:pt-12">
          <HeroMedia media={mediaCenter?.hero_media} />
        </div>
      </div>}
      {mediaCenter?.show_call && <div className="flex justify-center w-full">
        <Announcement
          data={mediaCenter?.active_call}
          qa={mediaCenter?.qa}
          isActive={globalConfiguration?.ambulante_presenta}
          inactiveData={mediaCenter?.inactive_call}
          type="presenta"
        />
      </div>}
      <div className="space-y-3">
        <DownloadableMaterials data={mediaCenter?.downloads} label="Materiales descargables AP 2024" />
        {mediaCenter?.past_downloads?.length > 0 ?
          <DownloadableMaterials data={mediaCenter?.past_downloads} label="Materiales descargables (ediciones anteriores)" />
          : null}
      </div>
      <div className="flex items-center justify-center w-full mb-8 bg-black">
        <div className="max-w-[1440px] bg-black px-4 py-10 text-white sm:w-full md:flex md:justify-between md:gap-16 md:px-12 lg:w-full lg:px-40">
          {mediaCenter?.stats.map((stat, i) => (
            <div className="mb-12 text-center md:mb-0" key={i}>
              <Text.Display
                as="p"
                className="mb-2 text-5xl font-bold md:text-[40px]"
              >
                {stat?.stat}
              </Text.Display>
              <Text.Headline
                as="p"
                className="mb-2 text-[32px] font-bold md:text-[28px]"
              >
                {stat?.title}
              </Text.Headline>
              <Text.Noun as="p" className="text-xl md:text-base ">
                {stat?.description}
              </Text.Noun>
            </div>
          ))}
        </div>
      </div>

      <PreviousEditions />
      <div className="flex items-center justify-center px-2 md:px-0">
        <Testimonials
          title={"El cine documental"}
          subtitle={"al alcance de todes"}
          quotes={mediaCenter?.quotes}
        />
      </div>
      <div className="mb-20">
        <Partners arrayPartners={mediaCenter?.aliados[0]?.aliado} />
      </div>

    </>
  );
}

export async function getServerSideProps() {
  try {
    const q = qs.stringify({
      populate: {
        qa: "*",
        stats: "*",
        quotes: "*",
        active_call: "*",
        inactive_call: "*",
        downloads: "*",
        past_downloads: "*",
        show_call: "*",
        hero_media: "*",
        aliados: {
          populate: {
            aliado: {
              populate: {
                logo: "*",
              },
            },
          },
        },
      },
    });
    const { data } = await apiClient.get(`/api/ambulante-presenta?${q}`);
    return {
      props: {
        mediaCenter: data.data.attributes,
      },
    };
  } catch (err) {
    console.log(err);
    return {
      notFound: true,
    };
  }
}
